module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": "",
      "visible": _vm.dialogVisible,
      "size": "small",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "label-width": "160px"
    }
  }, [_c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "销售下单号"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.OrderCode))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "订单状态"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.OrderStatusName))])]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.OrderData.PackageId !== 1201),
      expression: "OrderData.PackageId!==1201"
    }],
    attrs: {
      "label": "发货状态"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.SendStatusName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "代理商"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.AgentCode) + " " + _vm._s(_vm.OrderData.AgentName) + " " + _vm._s(_vm.OrderData.AgentAddress) + " " + _vm._s(_vm.OrderData.AgentTel))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": " "
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.AccountInfo))])]), _vm._v(" "), (_vm.OrderData.PackageId == 1201) ? _c('el-form-item', {
    attrs: {
      "label": "所选区域"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.AreaApplyList[0].ProvName) + " " + _vm._s(_vm.OrderData.AreaApplyList[0].CityName) + " " + _vm._s(_vm.OrderData.AreaApplyList[0].AreaName))])]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "销售下单时间"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.OrderTime))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "业务员"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.SaleEmployeeName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "下单对象"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.ObjectName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所选套餐"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.OrderTitle))])]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.OrderData.PackageId == 599),
      expression: "OrderData.PackageId==599"
    }],
    attrs: {
      "label": "套餐明细"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "80%",
      "margin-left": "0px"
    },
    attrs: {
      "data": _vm.OrderData.PackageList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "套餐名称"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.PackageName) + "\n                            "), (scope.row.ChargeTypeName !== '') ? _c('span', [_vm._v("(" + _vm._s(scope.row.ChargeTypeName) + ")")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ClassNum",
      "label": "开班数"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowClassNum),
      expression: "isShowClassNum"
    }],
    attrs: {
      "label": "开通班级数"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.ClassNum))])]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.OrderData.SubjectNames != ''),
      expression: "OrderData.SubjectNames!=''"
    }],
    attrs: {
      "label": "所选课程"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.SubjectNames))])]), _vm._v(" "), (_vm.OrderData.ProjectType == 2 && _vm.OrderData.PackageId != 202) ? _c('div', [_c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "Hi幼教样机数量"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.ProtoTypeNum))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "样机已抵扣数"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.ProtoTypeDeductibleNum))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "此单需抵扣数"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.OrderProtoTypeDeductibleNum))])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "bold"
    }
  }, [_vm._v("关联支付教室终端借用订单：" + _vm._s(_vm.OrderData.UnionRentTemplet.UnionRentRetainagePrice) + "元")])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "w100",
    attrs: {
      "label": " "
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "80%",
      "margin-left": "0px"
    },
    attrs: {
      "data": _vm.OrderData.UnionRentTemplet.UnionRentList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "SendCode",
      "label": "发货单号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "OrderCode",
      "label": "订单号"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.OrderData.PackageId == 202 && _vm.OrderData.PackageId !== 1201) ? _c('el-form-item', {
    staticClass: "w100",
    attrs: {
      "label": "商品"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "80%",
      "margin-left": "0px"
    },
    attrs: {
      "data": _vm.OrderData.ReturnProductList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "退换资源包",
      "align": "center"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "ReturnProName",
      "label": "商品名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ReturnNum",
      "label": "商品数量"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "预计换货资源包",
      "align": "center"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "ChangeProName",
      "label": "商品名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ReturnNum",
      "label": "商品数量"
    }
  })], 1)], 1)], 1) : _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.OrderData.ProductList != '' && _vm.OrderData.PackageId !== 1201),
      expression: "OrderData.ProductList!='' && OrderData.PackageId!==1201"
    }],
    staticClass: "w100",
    attrs: {
      "label": "商品"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "data": _vm.OrderData.ProductList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "ProductName",
      "label": "商品名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ProNum",
      "label": "商品数量"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.OrderData.PackageId == 1201),
      expression: "OrderData.PackageId==1201"
    }],
    staticClass: "w100",
    attrs: {
      "label": "商品"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "data": [],
      "empty-text": "该订单不存在实物商品",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "商品名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品数量"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "label": " "
    }
  }, [(_vm.OrderData.PackageId == 202) ? _c('span', {
    staticClass: "bigSp"
  }, [_vm._v("管理费:")]) : _c('span', {
    staticClass: "bigSp"
  }, [_vm._v("销售总价:")]), _vm._v(" "), _c('span', {
    staticClass: "bigSp"
  }, [_vm._v(_vm._s(_vm.OrderData.PreOrderPrice) + "元 ")]), _vm._v(" "), _c('span', {
    staticClass: "bigSp",
    staticStyle: {
      "margin-left": "15px"
    }
  }, [_vm._v(_vm._s(_vm.OrderData.OrderUnionRentPrice))])]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowXgPrice && _vm.OrderData.PackageId !== 1201),
      expression: "isShowXgPrice && OrderData.PackageId!==1201"
    }],
    attrs: {
      "label": " "
    }
  }, [_c('span', {
    staticClass: "bigSp"
  }, [_vm._v("修改后价格:")]), _vm._v(" "), _c('span', {
    staticClass: "bigSp"
  }, [_vm._v(_vm._s(_vm.OrderData.CurrentOrderPrice) + "元 (备注:" + _vm._s(_vm.OrderData.ChangePriceRemark) + ")")])]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "label": " "
    }
  }, [_c('span', {
    staticClass: "bigSp"
  }, [_vm._v("需支付:")]), _vm._v(" "), _c('span', {
    staticClass: "bigSp"
  }, [_vm._v(_vm._s(_vm.OrderData.OrderActualPrice) + "元 (备注:" + _vm._s(_vm.OrderData.DeductibleInfo) + ")")])]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.OrderData.GiftList != ''),
      expression: "OrderData.GiftList!=''"
    }],
    attrs: {
      "label": "赠品"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "data": _vm.OrderData.GiftList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "ProductName",
      "label": "赠品名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ProNum",
      "label": "赠品数量"
    }
  })], 1)], 1), _vm._v(" "), _vm._l((this.OrderData.PayList), function(item, index) {
    return _c('el-row', [_c('el-form-item', {
      attrs: {
        "label": '支付方式-' + (index + 1)
      }
    }, [_c('span', [_vm._v(_vm._s(item.PayWayName))])]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "支付金额"
      }
    }, [_c('span', [_vm._v(_vm._s(item.OrderActualPrice))])]), _vm._v(" "), (item.PayWay == 5) ? _c('el-form-item', {
      attrs: {
        "label": "支付凭证"
      }
    }, _vm._l((item.changePic), function(item2) {
      return _c('div', {
        attrs: {
          "id": "ImgPrev"
        }
      }, [_c('div', {
        staticClass: "post-format-content"
      }, [_c('div', {
        staticClass: "post-thumbnail"
      }, [_c('img', {
        staticClass: "attachment-thumbnail wp-post-image",
        attrs: {
          "id": "myProPic",
          "src": item2.Url
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "content-wrap"
      }, [_c('span', {
        staticClass: "entry-title"
      }, [_c('span', {
        staticClass: "featured-image",
        on: {
          "click": function($event) {
            _vm.LookPicture(item2.Url, _vm.changePic)
          }
        }
      }, [_c('i', {
        staticClass: "el-icon-view"
      })])])])])])
    })) : _vm._e(), _vm._v(" "), (item.Trade_No != '') ? _c('el-form-item', {
      attrs: {
        "label": "支付凭证单号"
      }
    }, [_c('span', [_vm._v(_vm._s(item.Trade_No))])]) : _vm._e(), _vm._v(" "), (item.PayWay == 8) ? _c('el-form-item', {
      attrs: {
        "label": "支付说明"
      }
    }, [_c('span', [_vm._v(_vm._s(item.PayRemark))])]) : _vm._e()], 1)
  }), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isPayWayShow),
      expression: "isPayWayShow"
    }]
  }, [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.OrderData.IsShowPrice),
      expression: "OrderData.IsShowPrice"
    }],
    attrs: {
      "label": "凭证"
    }
  }, _vm._l((_vm.OrderData.VoucherPic), function(item, index) {
    return _c('div', {
      attrs: {
        "id": "ImgPrev"
      }
    }, [_c('div', {
      staticClass: "post-format-content"
    }, [_c('div', {
      staticClass: "post-thumbnail"
    }, [_c('img', {
      staticClass: "attachment-thumbnail wp-post-image",
      attrs: {
        "id": "myProPic",
        "src": item.Url
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content-wrap"
    }, [_c('span', {
      staticClass: "entry-title"
    }, [_c('span', {
      staticClass: "featured-image",
      on: {
        "click": function($event) {
          _vm.LookPicture(item.Url)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-view"
    })])])])])])
  })), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.OrderData.ApplyPic.length > 0),
      expression: "OrderData.ApplyPic.length>0"
    }],
    attrs: {
      "label": "租用申请表"
    }
  }, [_c('div', {
    staticClass: "show-img-ctn uclear"
  }, [_vm._l((_vm.OrderData.ApplyPic), function(item, index) {
    return [_c('div', {
      staticClass: "show-img-cell",
      on: {
        "click": function($event) {
          _vm.LookPicture(item.Url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": item.Name,
        "src": item.Url
      }
    })])]
  })], 2)])], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isPayWayShow && !_vm.isMeetOrder),
      expression: "isPayWayShow && !isMeetOrder"
    }]
  }, [_c('el-form-item', {
    attrs: {
      "label": "收款银行"
    }
  }, [_c('el-input', {
    staticClass: "w60",
    model: {
      value: (_vm.auditFormData.Bank),
      callback: function($$v) {
        _vm.$set(_vm.auditFormData, "Bank", $$v)
      },
      expression: "auditFormData.Bank"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收款流水号"
    }
  }, [_c('el-input', {
    staticClass: "w60",
    model: {
      value: (_vm.auditFormData.BankRecord),
      callback: function($$v) {
        _vm.$set(_vm.auditFormData, "BankRecord", $$v)
      },
      expression: "auditFormData.BankRecord"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isMeetOrder),
      expression: "!isMeetOrder"
    }]
  }, [_c('el-form-item', {
    attrs: {
      "label": "收款金额"
    }
  }, [_c('el-input', {
    staticClass: "w60",
    model: {
      value: (_vm.auditFormData.AmountCollected),
      callback: function($$v) {
        _vm.$set(_vm.auditFormData, "AmountCollected", $$v)
      },
      expression: "auditFormData.AmountCollected"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.OrderData.PackageId !== 1201),
      expression: "OrderData.PackageId!==1201"
    }]
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowJszdByPolicyType),
      expression: "isShowJszdByPolicyType"
    }]
  }, [_c('h3', [_vm._v("教室终端（园所）")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "收货地址"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.AgentConsignee))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "收货人及联系方式"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.Consignee) + "  " + _vm._s(_vm.OrderData.ConsigneeTel))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "寄送方式(资源包)"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.SchoolSendModeName))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "寄送支付方式"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.SchoolPayModeName))])])], 1), _vm._v(" "), _c('h3', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowJszdByPolicyType),
      expression: "isShowJszdByPolicyType"
    }]
  }, [_vm._v("资源包（代理商）")]), _vm._v(" "), (_vm.OrderData.PackageId !== 1200 && _vm.OrderData.PackageId !== 10021) ? _c('div', [_c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "收货地址"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.AG_Address))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "收货人及联系方式"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.AG_Consignee) + "  " + _vm._s(_vm.OrderData.AG_ConsigneeTel))])])], 1) : _c('div', [_c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "收货地址"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.AgentConsignee))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "收货人及联系方式"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.Consignee) + "  " + _vm._s(_vm.OrderData.ConsigneeTel))])])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "下单备注"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.OrderRemark))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "寄送方式",
      "label-width": "150px"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.OrderData.SendMode),
      callback: function($$v) {
        _vm.$set(_vm.OrderData, "SendMode", $$v)
      },
      expression: "OrderData.SendMode"
    }
  }, _vm._l((_vm.transportList), function(item) {
    return _c('el-radio', {
      attrs: {
        "label": item.Id
      }
    }, [_vm._v(_vm._s(item.ParmName))])
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "寄送支付方式",
      "label-width": "150px"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.OrderData.PayMode),
      callback: function($$v) {
        _vm.$set(_vm.OrderData, "PayMode", $$v)
      },
      expression: "OrderData.PayMode"
    }
  }, _vm._l((_vm.PayList), function(item) {
    return _c('el-radio', {
      attrs: {
        "label": item.Id
      }
    }, [_vm._v(_vm._s(item.ParmName))])
  }))], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "审核备注"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.auditFormData.AuditRemark),
      callback: function($$v) {
        _vm.$set(_vm.auditFormData, "AuditRemark", $$v)
      },
      expression: "auditFormData.AuditRemark"
    }
  })], 1)], 2), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.dialogClose
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("审核通过")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.PictureVisible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.PictureVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-32bbc3aa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Order/financialList/components/financialAuditView/index.vue
// module id = 1441
// module chunks = 1